import IFormPostHandler from '../../forms/IFormPostHandler';
import { ValidateFormResult } from '../../forms/types';
import { ValidationResult } from '../../forms/ValidationService';
import ajax from '../../utils/ajax';
import type EventsDetailTicketSelector from './EventsDetailTicketSelector';
import EventsDetailTicketSelectorResponseTypes from './EventsDetailTicketSelectorResponseTypes';

export default class EventsDetailTicketSelectorFormPostHandler implements IFormPostHandler {
  ticketSelector: EventsDetailTicketSelector;
  postUrl: string;

  constructor(ticketSelector: EventsDetailTicketSelector, isFromAdditionalItemPage: boolean = false) {
      this.ticketSelector = ticketSelector;
      this.postUrl = isFromAdditionalItemPage
          ? '/api/tickets/reservation/reserveadditionalitems'
          : '/api/tickets/reservation';
  }

  async post() {
    const response = await ajax.postWwwFormUrlEncoded(this.postUrl, this.ticketSelector.getPostData());

    const returnValue:ValidateFormResult = {
      data: response,
      validationResult: {
        validationResults: [],
        isValid: true,
      },
    };

    if (response.type === EventsDetailTicketSelectorResponseTypes.ValidationError) {
      const validationResults = response.validationResult as ValidationResult[];

      returnValue.validationResult = {
        validationResults,
        isValid: validationResults.every((el) => el.isValid),
      };
    }

    return returnValue;
  }
}
